import gql from 'graphql-tag';

export const CreateFolderMutation = gql`
	mutation CreateFolderMutation(
		$parentId: ID
		$spaceKey: String
		$type: String!
		$status: GraphQLContentStatus!
	) {
		createContentContextual(
			input: { parentId: $parentId, spaceKey: $spaceKey, type: $type, status: $status }
		) {
			id
			space {
				id
				key
				alias
			}
		}
	}
`;
